import { useResponsive } from "../../../../components/responsive";
import DepositQRCodeMobile from "./DepositQRCodeMobile";
import DepositQRCodeDesktop from "./DepositQRCodeDesktop";
import CashierWrapper from "../CashierWrapper/CahiserWrapper";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { useCallback, useEffect, useMemo } from "react";
import { BONUS_NAMES } from "../../../Bonus/bonusesConstants";

function DepositQRCode(props) {
    const {getLangPath} = useLangContext();
    const {
        isSliderWrapper,
        onCompleteHandler,
        onUnMountHandler,
        payload,
        selectedPayment,
        setDepositQRCodeOpened,
        show,
    } = props;
    const {isMediumMaxWidth} = useResponsive();

    const handleClose = useCallback(() => {
        onCompleteHandler();
    }, [onCompleteHandler]);

    useEffect(() => {
        if (show && !payload) {
            setDepositQRCodeOpened(false);
        }
    }, [payload, setDepositQRCodeOpened, show]);

    const bonusAmount = payload?.bonus[BONUS_NAMES.WELCOME]?.amount || 0;

    const totalAmount = useMemo(() => {
        const transactionAmount = payload?.transaction?.amount || 0;
        return +transactionAmount + +bonusAmount;
    }, [bonusAmount, payload]);

    const childrenProps = {bonusAmount, onUnMountHandler, payload, selectedPayment, totalAmount};

    return <CashierWrapper show={show} handleClose={handleClose} isSlider={isSliderWrapper}
                           title={getLangPath('pix_qr.complete_payment')} sliderTitle={''}>
        {
            isMediumMaxWidth
                ? <DepositQRCodeMobile {...childrenProps}/>
                : <DepositQRCodeDesktop {...childrenProps}/>
        }
    </CashierWrapper>
}

export default DepositQRCode;
